// extracted by mini-css-extract-plugin
module.exports = {"word":"_3065e74aad271f1de67bd1f172612b77","display":"adbdf5edc4bd4093eca6b37f683af775"};